module.exports = __webpack_public_path__ + "static/media/card1.81d452f8.png";